import { Card, VStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";

import { TransactionGroupProps } from "./types";
import { TransactionItem } from "./TransactionItem";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export const TransactionGroup = ({ date, items }: TransactionGroupProps) => {
  const dateValue = new Date(date);

  return (
    <VStack pt="$2" pb="$4">
      <Text
        mb="$2"
        color="$textLight600"
        fontSize="$sm"
        textTransform="capitalize"
        fontWeight={500}
      >
        {format(dateValue, "cccc, dd/MM/yyyy", { locale: ptBR })}
      </Text>
      <Card p="$3" bgColor="$white">
        {items?.map((item, index) => (
          <TransactionItem
            {...item}
            key={index}
            showDivider={index < items.length - 1}
          />
        ))}
      </Card>
    </VStack>
  );
};
